// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import FoodReviewORGenericHighlight from './foodReviewORGeneric';

const FoodReviewHighlight = ({ match }) => {
  const pageId = match.params.id;

  return (
    <FoodReviewORGenericHighlight
      pageId={pageId}
      heading="Food Review"
      isGeneric={false}
    />
  );
};

export default FoodReviewHighlight;

FoodReviewHighlight.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};
